import { useParams } from "react-router-dom";
import investorData from "../Data/investorData";
import InvestorMenu from "../Component/InvestorMenu";
import PdfList from "../Component/PdfList";
import "../Styles/investor.css";

const Investor = () => {
  const { category } = useParams();
  const data = investorData[category];

  if (!data) return <h2>Data not found</h2>;

  return (
    <>
      <section className="invest">

        <div className="investor-image">
          <img src="/corporate/investor.png" alt="" />
        </div>

        <section className="investor-wrapper">

          <h1 className="page-title">{data.title}</h1>

          <div className="investor-layout">

            <InvestorMenu />

            <div className="investor-content">

              {/* TOP PDF FILES */}
              {data.files && data.files.length > 0 && (
                <PdfList files={data.files} />
              )}

              <br />

              {/* GROUP SECTIONS */}
              {data.groups && data.groups.length > 0 && (

                data.groups.map((group, index) => (

                  <div key={index} className="group-block">

                    <h3 className="group-title">{group.company}</h3>

                    {/* GROUP PDF */}
                    {group.files && group.files.length > 0 && (
                      <PdfList files={group.files} />
                    )}

                    {/* GROUP VIDEOS */}
                    {group.videos && group.videos.length > 0 && (
                      <div className="video-grid">
                        {group.videos.map((vid, i) => (
                          <video key={i} controls width="700">
                            <source src={vid.src} type="video/mp4" />
                          </video>
                        ))}
                      </div>
                    )}

                  </div>

                ))

              )}

              {/* IMAGES */}
              {data.images && data.images.length > 0 && (
                <div className="media-section">
                  <div className="image-grid">
                    {data.images.map((img, i) => (
                      <img key={i} src={img.src} alt={img.alt} />
                    ))}
                  </div>
                </div>
              )}

              {/* CONTACT SECTION */}
              {data.contacts && (
                <div className="contact-box" style={{ color: "black" }}>
                  {data.contacts.map((c, i) => (
                    <div key={i}>

                      <br />
                      <p style={{ color: "#2d5499" }}>{c.text}</p>
                      <br />

                      <h3 style={{ color: "#2d5499" }}>{c.name}</h3>

                      <p>{c.role}</p>
                      <p>{c.address}</p>
                      <p>Tel: {c.phone}</p>
                      <p>Email: {c.email}</p>

                      <br />
                      <br />

                    </div>
                  ))}
                </div>
              )}

            </div>

          </div>

        </section>

      </section>
    </>
  );
};

export default Investor;